import { render, staticRenderFns } from "./countriesSettingComponents.vue?vue&type=template&id=6ac9aac2&scoped=true&class=full-height&"
import script from "./countriesSettingComponents.vue?vue&type=script&lang=js&"
export * from "./countriesSettingComponents.vue?vue&type=script&lang=js&"
import style0 from "./countriesSettingComponents.vue?vue&type=style&index=0&id=6ac9aac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac9aac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac9aac2')) {
      api.createRecord('6ac9aac2', component.options)
    } else {
      api.reload('6ac9aac2', component.options)
    }
    module.hot.accept("./countriesSettingComponents.vue?vue&type=template&id=6ac9aac2&scoped=true&class=full-height&", function () {
      api.rerender('6ac9aac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/system/countriesMenu/components/countriesSettingComponents.vue"
export default component.exports